import { lazy } from 'react';
import { Skeleton } from '@picsart/ds-components/Skeleton';
import withSuspense from './withSuspense/index.js';
import { Typography } from '@picsart/ds-foundation/typography';
import { ScreenSizes } from '@picsart/ds-foundation/responsive';
import { TextElementTypes } from '@picsart/ds-components/Text';

var _a, _b, _c, _d, _e, _f, _g, _h, _j;
var TextSizes;
(function (TextSizes) {
  TextSizes["XXExtraLarge"] = "x-x-extra-large";
  TextSizes["XXLarge"] = "x-x-large";
  TextSizes["ExtraLarge"] = "extra-large";
  TextSizes["SemiExtraLarge"] = "semi-extra-large";
  TextSizes["Large"] = "large";
  TextSizes["Medium"] = "medium";
  TextSizes["Small"] = "small";
  TextSizes["Default"] = "default";
  TextSizes["Auto"] = "auto";
})(TextSizes || (TextSizes = {}));
var AllowedHeadingTags;
(function (AllowedHeadingTags) {
  AllowedHeadingTags["h1"] = "h1";
  AllowedHeadingTags["h2"] = "h2";
  AllowedHeadingTags["h3"] = "h3";
  AllowedHeadingTags["h4"] = "h4";
  AllowedHeadingTags["h5"] = "h5";
  AllowedHeadingTags["h6"] = "h6";
  AllowedHeadingTags["span"] = "span";
})(AllowedHeadingTags || (AllowedHeadingTags = {}));
var sizes = (_a = {}, _a[TextSizes.XXExtraLarge] = (_b = {
  Default: {
    fontSize: '100px',
    lineHeight: '120px'
  }
}, _b[ScreenSizes.LG] = {
  fontSize: '100px',
  lineHeight: '120px'
}, _b[ScreenSizes.MD] = {
  fontSize: '80px',
  lineHeight: '96px'
}, _b[ScreenSizes.SM] = Typography.t10, _b), _a[TextSizes.XXLarge] = (_c = {
  Default: {
    fontSize: '60px',
    lineHeight: '72px'
  }
}, _c[ScreenSizes.LG] = {
  fontSize: '60px',
  lineHeight: '72px'
}, _c[ScreenSizes.MD] = {
  fontSize: '60px',
  lineHeight: '72px'
}, _c[ScreenSizes.SM] = Typography.t9, _c), _a[TextSizes.ExtraLarge] = (_d = {
  Default: Typography.t10
}, _d[ScreenSizes.LG] = Typography.t10, _d[ScreenSizes.SM] = Typography.t9, _d), _a[TextSizes.SemiExtraLarge] = (_e = {
  Default: Typography.t8
}, _e[ScreenSizes.LG] = Typography.t8, _e[ScreenSizes.SM] = Typography.t7, _e), _a[TextSizes.Large] = (_f = {
  Default: Typography.t7
}, _f[ScreenSizes.LG] = Typography.t7, _f[ScreenSizes.SM] = Typography.t7, _f), _a[TextSizes.Medium] = (_g = {
  Default: Typography.t6
}, _g[ScreenSizes.LG] = Typography.t6, _g[ScreenSizes.SM] = Typography.t6, _g), _a[TextSizes.Small] = (_h = {
  Default: Typography.t5
}, _h[ScreenSizes.LG] = Typography.t5, _h[ScreenSizes.SM] = Typography.t5, _h), _a[TextSizes.Default] = {
  Default: Typography.t5
}, _a[TextSizes.Auto] = {}, _a);
var mapTagToCascadeElement = (_j = {}, _j[AllowedHeadingTags.h1] = TextElementTypes.H1, _j[AllowedHeadingTags.h2] = TextElementTypes.H2, _j[AllowedHeadingTags.h3] = TextElementTypes.H3, _j[AllowedHeadingTags.h4] = TextElementTypes.H4, _j[AllowedHeadingTags.h5] = TextElementTypes.H5, _j[AllowedHeadingTags.h6] = TextElementTypes.H6, _j[AllowedHeadingTags.span] = TextElementTypes.Span, _j);

var testIds = {
  headingTitle: 'heading-title'
};

var Title = withSuspense(/*#__PURE__*/lazy(function () {
  return import('./Title-8d7d4883.js');
}), Skeleton);

export { AllowedHeadingTags as A, Title as T, TextSizes as a, mapTagToCascadeElement as m, sizes as s, testIds as t };
//# sourceMappingURL=index-0943f287.js.map
